export const ANS_FR = {
    "ocQKxGk5q3FFxBPq9Kdg_fr": { "1": { "optionIndex": 2 } },
    "iZclyXfgpWoy3pa8dqxm_fr": { "1": { "optionIndex": 1 } },
    "lJML7ab0S1Fv2vjpTnBY_fr": { "1": { "optionIndex": 2 } },
    "hbHqrwxUoJ83qkfxJp6a_fr": { "1": { "optionIndex": 1 } },
    "T0TNcv58zwNZ3vxEHEox_fr": { "1": { "optionIndex": 0 } },
    "2idaVTf7GR3jzcGSabVe_fr": { "1": { "optionIndex": 1 } },
    "E1Hwk2WIDqcvjOxyBa11_fr": { "1": { "optionIndex": 1 } },
    "ygIyHj7pIUhgkBhazBJb_fr": { "1": { "optionIndex": 3 } },
    "NhBYPu2p5khticOZ3WvF_fr": { "1": { "optionIndex": 0 } },
    "6RlqxjRY0eBL3O1gz43g_fr": { "1": { "optionIndex": 0 } },
    "ZhzBvzbYuum6I684faQW_fr": { "1": { "optionIndex": 1 } },
    "UbiWkJjVNhqrBbzMEN4Z_fr": { "1": { "optionIndex": 2 } },
    "xlwBysp4htH8JSxWpS70_fr": { "1": { "optionIndex": 0 } },
    "X9XiUGvxhPCGvrr1Tg3q_fr": { "1": { "optionIndex": 2 } },
    "EwmjYJlVwXK01llno1oo_fr": { "1": { "optionIndex": 3 } },
    "MoEOS5Rr9MVOy2IxJCnk_fr": { "1": { "optionIndex": 2 } },
    "BzfDy2WgIXHjL2ChbEIM_fr": { "1": { "optionIndex": 3 } },
    "IXUD7Gmi8woPQ4ebkGMW_fr": { "1": { "optionIndex": 2 } },
    "RkCEj2qP01YMlTu0D4IC_fr": { "1": { "optionIndex": 1 } },
    "GnaDr73h7tQ4vjdpGXXO_fr": { "1": { "optionIndex": 2 } },
    "wgBhJ6qTRlC5nnUI9797_fr": { "1": { "optionIndex": 2 } },
    "rSZABv0A2p1oB83d1Rgg_fr": { "1": { "optionIndex": 0 } },
    "6gjFwZypGLuzpAJh49Pe_fr": { "1": { "optionIndex": 3 } },
    "WjyYGWo0EZG8Zeqs8ABt_fr": { "1": { "optionIndex": 0 } },
    "D29AD1Z64eDGLf6xRKLt_fr": { "1": { "optionIndex": 1 } },
    "4K4Dipw8Iy2PldPxCc7G_fr": { "1": { "optionIndex": 2 } },
    "2zEzs8UzXdUJalwmKPRe_fr": { "1": { "optionIndex": 1 } },
    "xrRKElsXSdwKSAlORAFb_fr": { "1": { "optionIndex": 2 } },
    "TsBjuSxGmNyoe2rkPyrw_fr": { "1": { "optionIndex": 3 } },
    "YOVYOsmzfqzW3EvJrWsZ_fr": { "1": { "optionIndex": 1 } },
    "5sy3s2LCSwaHWuzD8Cyn_fr": { "1": { "optionIndex": 2 } },
    "6nWnaLKde3jdZktQjZbX_fr": { "1": { "optionIndex": 3 } }
}